// extracted by mini-css-extract-plugin
export default {"base":"TextLink_base__fPwMa","is-disabled":"TextLink_is-disabled__y9br3"};